function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dealtScheduleListApi, noticeMessageListApi, userAssessSubord, userWorkMenusApi, userWorkCountApi, scheduleListApi, scheduleTypesApi, scheduleStatusApi, enterpriseUserJoinApi, workStatisticsApi, workStatisticsApiAll } from '@/api/user';
import { auth } from '@/api/setting';
import { noticeListApi } from '@/api/administration';
import { clientRemindDetailApi } from '@/api/enterprise';
import { mapGetters } from 'vuex';
import { pageJumpTo } from '@/libs/public';
import ElementUI from 'element-ui';
import { roterPre } from '@/settings';
import { configRuleApproveApi } from '@/api/config';
export default {
  name: 'Workbench',
  components: {
    echarts: function echarts() {
      return import('./components/echart');
    },
    enterprise: function enterprise() {
      return import('./components/enterprise');
    },
    password: function password() {
      return import('./components/password');
    },
    contractDialog: function contractDialog() {
      return import('@/views/customer/contract/components/contractDialog');
    },
    defaultPage: function defaultPage() {
      return import('@/components/common/defaultPage');
    },
    messageDetails: function messageDetails() {
      return import('@/views/user/news/components/messageDetails');
    },
    quickManage: function quickManage() {
      return import('./components/quickManage');
    },
    calendarDetails: function calendarDetails() {
      return import('@/views/user/calendar/components/calendarDetails');
    },
    recordUpload: function recordUpload() {
      return import('@/views/customer/list/components/recordUpload');
    },
    addTodo: function addTodo() {
      return import('@/views/user/calendar/components/addTodo');
    },
    noticeList: function noticeList() {
      return import('@/layout/components/Notice/noticeList');
    },
    editExamine: function editExamine() {
      return import('@/views/user/examine/components/editExamine');
    },
    copyright: function copyright() {
      return import('@/layout/components/copyright.vue');
    }
  },
  data: function data() {
    return {
      noticeListVisible: false,
      addTodoVisible: false,
      calendarDetailsVisible: false,
      contractDialogVisible: false,
      workBackground: '',
      enterpriseCulture: '',
      realName: this.$store.state.user.userInfo.name,
      noon: this.$moment(new Date()).format('a'),
      pend: {
        status: 3
      },
      dialogVisible: false,
      configContract: {},
      formInfo: {
        avatar: '',
        type: 'add',
        show: 1,
        data: {},
        follow_id: 0
      },
      needList: [],
      value: new Date(),
      calendar: {
        time: this.$moment(new Date()).format('YYYY-MM') // 当月
      },
      dailyList: {},
      // 点击当前天数的计划与总结
      currentDay: this.$moment(new Date()).format('DD'),
      // 当天
      dailyDay: [],
      // 当月有日报的天数组合
      imgList: [],
      achievementList: [],
      // 业绩统计数组
      rolesConfig: {},
      formBoxConfig: {},
      entConfig: {},
      entBoxConfig: {},
      types: [],
      scheduleTypes: [],
      time: this.$moment(new Date()).format('yyyy-MM-DD'),
      // scheduleData: {},
      itemArray: [],
      passwordData: {},
      calendarConut: [],
      userId: '',
      nweNoticeData: [],
      defaultImage: require('@/assets/images/notice.png'),
      userInfo: {},
      systemNote: [],
      // 系统通知
      timeTab: 1,
      timeTabData: [{
        text: '前一天',
        label: 0
      }, {
        text: '今天',
        label: 1
      }, {
        text: '后一天',
        label: 2
      }],
      timeTabIndex: 1,
      timeTabLoading: false,
      timeTabNum: 0,
      needInfo: [{
        icon: require('@/assets/images/personal-icon-01.png'),
        text: '待办任务',
        num: 0,
        path: '/user/calendar/index',
        type: -1
      }, {
        icon: require('@/assets/images/personal-icon-04.png'),
        text: '我的申请',
        num: 0,
        path: '/user/examine/mine',
        type: 1
      }, {
        icon: require('@/assets/images/personal-icon-03.png'),
        text: '待我审批',
        num: 0,
        path: '/user/examine/approval',
        type: 0
      }, {
        icon: require('@/assets/images/personal-icon-02.png'),
        text: '企业动态',
        num: 0,
        path: '/user/notice/index',
        type: -1
      }],
      options: [{
        value: 0,
        label: '部门业绩'
      }, {
        value: 1,
        label: '本人业绩'
      }],
      achievementTypes: 0,
      quickData: [],
      quickVal: [],
      assessNowData: [],
      assessLoading: false,
      messageData: {},
      configData: {},
      parameterData: {
        contract_id: '',
        customer_id: '',
        invoice_id: '',
        bill_id: ''
      },
      buildData: [],
      item: {},
      status: 0
    };
  },
  computed: _objectSpread({
    hasFinished: function hasFinished() {
      var arrList = [];
      this.needList.map(function (item) {
        arrList.push(item);
      });
      return arrList.some(function (item) {
        return item.finish >= 2;
      });
    },
    hasUnfinished: function hasUnfinished() {
      return this.needList.some(function (item) {
        return item.finish <= 1;
      });
    }
  }, mapGetters(['enterprise'])),
  watch: {
    value: function value(_value) {
      this.getScheduleDay(this.$moment(_value).format('yyyy-MM-DD'), 1);
    }
  },
  mounted: function mounted() {
    this.workStatisticsList();
    this.getAssessMine();
    this.getInvitation();
    this.getPassword();
    this.getNewTableData();
    this.getTypes();
    this.getNewListData();
    this.getUserWorkMenus();
    this.entAuth();
    this.getUserWorkCount();
    this.getConfigApprove();
    this.userId = JSON.parse(localStorage.getItem('userInfo')).id;
    this.formInfo.avatar = JSON.parse(localStorage.getItem('userInfo')).avatar;
  },
  methods: {
    // 业绩统计
    workStatisticsList: function workStatisticsList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return workStatisticsApi(_this.achievementTypes);
            case 2:
              result = _context.sent;
              _this.achievementList = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 跳转到业绩统计
    performanceFn: function performanceFn() {
      this.$router.push({
        path: "".concat(roterPre, "/customer/turnover/index"),
        query: {}
      });
    },
    // 打开业绩统计弹窗
    handlePerformance: function handlePerformance() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, otherData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return workStatisticsApiAll();
            case 2:
              result = _context2.sent;
              otherData = [{
                cate_name: '业绩简报',
                fast_entry: result.data.list
              }];
              _this2.configData = {
                title: '业绩统计管理',
                type: 'statistics',
                width: '600px',
                data: result.data.select,
                otherArr: otherData
              };
              _context2.next = 7;
              return _this2.$refs.quickManage.handleOpen(_this2.configData);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 关闭跟进弹窗
    recordChange: function recordChange() {
      this.dialogVisible = false;
      this.getDailyTodo();
    },
    // 获取授权信息
    entAuth: function entAuth() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var obj, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return auth();
            case 2:
              obj = _context3.sent;
              data = obj.data;
              if (!(data.status === -1)) {
                _context3.next = 7;
                break;
              }
              _context3.next = 7;
              return _this3.getAuthMessage("\u60A8\u7684\u6388\u6743\u8BC1\u4E66\u8FD8\u6709".concat(data.day, "\u5929\u8FC7\u671F,\u8BF7\u53CA\u65F6\u524D\u5F80\u9640\u87BA\u5320\u5B98\u65B9\u8FDB\u884C\u6388\u6743\u8BA4\u8BC1!"));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 提醒授权弹窗
    getAuthMessage: function getAuthMessage(message) {
      var content = "<div class='el-row display-align'>\n        <div class=\"el-col el-col-24 right width100\">\n          <p class='title over-text'>\u6388\u6743\u63D0\u9192</p>\n          <p class='caption over-text2'>".concat(message, "</p>\n        </div>\n      </div>\n      <div class='text-right'>\n        <button id=\"messageOpen\" type=\"button\" class=\"el-button el-button--text el-button--small\"><span>\u7ACB\u5373\u6388\u6743</span></button>\n      </div>");
      var notify = ElementUI.Notification({
        title: '消息',
        dangerouslyUseHTMLString: true,
        message: content,
        duration: 10000,
        offset: 60,
        iconClass: 'iconfont iconxiaoxi',
        customClass: 'message-socket'
      });
      var oBtn = document.getElementById('messageOpen');
      oBtn.addEventListener('click', function () {
        pageJumpTo('/setting/auth/auth/index');
        notify.close();
      });
    },
    // 编辑代办日程
    editFn: function editFn(id, type, date) {
      var _this4 = this;
      var data = {
        id: id,
        type: type,
        edit: true,
        date: date
      };
      this.addTodoVisible = true;
      setTimeout(function () {
        _this4.$refs.addTodo.openBox(data);
      }, 200);
    },
    // 打开系统消息弹窗
    handleDetails: function handleDetails(row) {
      this.messageData = {
        width: '560px',
        data: row
      };
      this.$refs.messageDetails.handleOpen();
    },
    // 处理数据
    findItem: function findItem(arr, key, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id === val || arr[i].id == this.userId) {
          return 2;
        }
      }
      return -1;
    },
    getDailyTodo: function getDailyTodo() {
      this.getDailyTodoInfo(this.time);
    },
    getDailyTodoInfo: function getDailyTodoInfo(time) {
      var _this5 = this;
      var load = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (load) {
        this.timeTabLoading = true;
      }
      var start_time = this.$moment(time).format('YYYY-MM-DD') + ' 00:00:00';
      var end_time = this.$moment(time).format('YYYY-MM-DD') + ' 23:59:59';
      var data = {
        start_time: start_time,
        end_time: end_time,
        cid: this.types,
        period: 1
      };
      scheduleListApi(data).then(function (res) {
        res.data.forEach(function (item, index) {
          var len = _this5.findItem(item.user, 'id', item.master.id);
          if (len == -1) {
            res.data.splice(index, 1);
          }
        });
        _this5.needList = res.data;
        if (_this5.needList.length > 1) {
          _this5.needList.sort(function (a, b) {
            return a.finish - b.finish;
          });
        }
        if (load) {
          _this5.timeTabLoading = false;
        }
      }).catch(function (error) {
        if (load) {
          _this5.timeTabLoading = false;
        }
      });
    },
    getTypes: function getTypes() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return scheduleTypesApi();
            case 2:
              result = _context4.sent;
              _this6.scheduleTypes = result.data;
              result.data.map(function (value) {
                _this6.types.push(value.id);
              });
              _context4.next = 7;
              return _this6.getDailyTodoInfo(_this6.$moment(new Date()).format('yyyy-MM-DD'));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    dealtItemColor: function dealtItemColor(type) {
      var str = '';
      if (this.scheduleTypes.length > 0) {
        for (var i = 0; i < this.scheduleTypes.length; i++) {
          var value = this.scheduleTypes[i];
          if (value.key === type) {
            str = value.color;
            break;
          }
        }
      }
      return str;
    },
    // 当天提醒
    pendList: function pendList() {
      var time = this.$moment(new Date()).format('yyyy-MM-DD');
      this.getScheduleDay(time, 1);
    },
    getScheduleDay: function getScheduleDay(time, type) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, result, res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              data = {
                time: time,
                types: _this7.types,
                period: 0
              };
              _context5.next = 3;
              return dealtScheduleListApi(data);
            case 3:
              result = _context5.sent;
              res = result.data[0].list;
              if (type === 1) {
                res.sort(function (a, b) {
                  return a.finish - b.finish;
                });
                _this7.needList = res;
              }
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 提醒状态
    scheduleRecord: function scheduleRecord(data, status) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var info, id;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              info = {
                status: status ? status : _this8.status,
                start: data ? data.start_time : _this8.item.start_time,
                end: data ? data.end_time : _this8.item.end_time
              };
              id = data ? data.id : _this8.item.id;
              _context6.next = 4;
              return scheduleStatusApi(id, info);
            case 4:
              _context6.next = 6;
              return _this8.getDailyTodo();
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getConfigApprove: function getConfigApprove() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var result;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return configRuleApproveApi(0);
            case 2:
              result = _context7.sent;
              _this9.buildData = result.data;
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // 修改代办日程状态
    setScheduleRecord: function setScheduleRecord(item, status) {
      var _this10 = this;
      this.item = item;
      this.status = status;
      this.contractDialogVisible = true;
      if (item == 2) {
        return this.$message.error('您已拒绝该任务！');
      }
      if (item.cid == 3 || item.cid == 4) {
        var id = item.relation.bill_id !== 0 ? item.relation.bill_id : item.relation.remind_id;
        if (status == 3) {
          clientRemindDetailApi(id).then(function (res) {
            res.data.id = item.relation.remind_id;
            _this10.parameterData.customer_id = res.data.eid;
            _this10.parameterData.contract_id = res.data.cid;
            if (res.data.types == 0) {
              var data = {
                id: _this10.buildData.contract_refund_switch
              };
              _this10.$refs.editExamine.openBox(data, res.data.cid, 'contract_refund_switch', item, status);
            } else {
              var _data = {
                id: _this10.buildData.contract_renew_switch
              };
              _this10.$refs.editExamine.openBox(_data, res.data.cid, 'contract_renew_switch', item, status);
            }
          });
        }
      } else if (item.cid == 2) {
        if (item.finish == 3) {
          return false;
        }
        this.formInfo.data.id = item.link_id;
        this.formInfo.follow_id = item.relation ? item.relation.follow_id : 0;
        this.dialogVisible = true;
      } else {
        var newArr = [];
        this.needList.map(function (val) {
          if (val.id == item.id) {
            val.finish = status;
          }
          newArr.push(val);
        });
        this.needList = newArr;
        this.scheduleRecord(item, status);
      }
    },
    // 初始密码修改
    getPassword: function getPassword() {
      if (this.$store.state.user.userInfo.is_init === 1) {
        this.passwordData = {
          title: '修改密码',
          width: '540px'
        };
        this.$refs.password.handleOpen();
      }
    },
    // 链接邀请
    getInvitation: function getInvitation() {
      var invitationStorage = localStorage.getItem('invitationStorage');
      var invitation = JSON.parse(invitationStorage);
      if (invitationStorage !== null) {
        this.getEnterpriseInfo(invitation);
      }
    },
    getEnterpriseInfo: function getEnterpriseInfo(invitation) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return enterpriseUserJoinApi({
                invitation: invitation.invitation
              });
            case 2:
              _context8.next = 4;
              return localStorage.removeItem('invitationStorage');
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // 点击我的待办与我的已办
    handleItemClick: function handleItemClick(item) {
      var _this11 = this;
      item.itemId = item.id;
      this.calendarDetailsVisible = true;
      setTimeout(function () {
        _this11.$refs.calendarDetails.openBox(item);
      }, 200);
    },
    // 跳转到企业动态
    handleNoticeMore: function handleNoticeMore() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var data = id ? {
        id: id
      } : {};
      pageJumpTo('/user/notice/index', data);
    },
    // 打开系统通知弹窗
    handleNewMore: function handleNewMore() {
      var _this12 = this;
      this.noticeListVisible = true;
      this.$nextTick(function () {
        _this12.$refs.noticeList.openBox();
      });
    },
    // 点击快捷菜单跳转
    quickItem: function quickItem(item) {
      pageJumpTo(item.pc_url);
    },
    // 跳转到绩效考核
    handleAssessMore: function handleAssessMore() {
      pageJumpTo('/user/assessment/my');
    },
    // 业绩考核
    getAssessMine: function getAssessMine() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              data = {
                handle: 1,
                time: '',
                status: 1
              };
              _context9.next = 3;
              return userAssessSubord(data);
            case 3:
              result = _context9.sent;
              _this13.assessLoading = true;
              _this13.assessNowData = result.data.list ? result.data.list : [];
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    // 顶部页面跳转
    needInfoItem: function needInfoItem(item) {
      if (!item.path) return;
      pageJumpTo(item.path);
    },
    // 获取系统消息列表
    getNewListData: function getNewListData() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var result;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return noticeMessageListApi({
                page: 1,
                limit: 11,
                cate_id: '',
                is_read: ''
              });
            case 2:
              result = _context10.sent;
              _this14.systemNote = result.data.list;
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    // 获取企业动态列表
    getNewTableData: function getNewTableData() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var result;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return noticeListApi({
                is_new: 1,
                status: 1
              });
            case 2:
              result = _context11.sent;
              _this15.nweNoticeData = result.data.list || [];
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    // 获取快捷入口列表
    getUserWorkMenus: function getUserWorkMenus() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var result;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this16.quickVal = [];
              _context12.next = 3;
              return userWorkMenusApi();
            case 3:
              result = _context12.sent;
              _this16.quickData = result.data;
              _this16.quickVal = result.data.checkd;
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    // 快捷管理子传父事件
    quickSuccess: function quickSuccess() {
      this.workStatisticsList();
      this.getUserWorkMenus();
    },
    // 获取顶部四列数据
    getUserWorkCount: function getUserWorkCount() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var result, data;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return userWorkCountApi();
            case 2:
              result = _context13.sent;
              data = result.data;
              _this17.needInfo[0].num = data.scheduleCount;
              _this17.needInfo[1].num = data.applyCount;
              _this17.needInfo[2].num = data.approveCount;
              _this17.needInfo[3].num = data.noticeCount;
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    // 日期切换
    timeTabInput: function timeTabInput(e, index) {
      this.timeTabIndex = index;
      if (e.label === 1 && this.timeTabNum === 0) return;
      if (e.label === 0) {
        this.timeTabNum--;
      } else if (e.label === 1) {
        this.timeTabNum = 0;
      } else {
        this.timeTabNum++;
      }
      this.time = this.$moment(new Date()).add(this.timeTabNum, 'day').format('yyyy-MM-DD');
      this.getDailyTodoInfo(this.time, true);
    },
    // 打开快捷管理弹窗
    handleQuick: function handleQuick() {
      var arr = [];
      arr = JSON.parse(JSON.stringify(this.quickVal));
      var otherArr = this.quickData.cates;
      this.configData = {
        title: '快捷入口管理',
        width: '600px',
        data: arr,
        otherArr: otherArr
      };
      this.$refs.quickManage.handleOpen(this.configData);
    }
  }
};